import { type StopInfo } from 'core/domain/StopInfo'
import { getLaneDescription } from 'core/presenters/lanePresenter'
import { formatDate, parseISO } from 'core/utils/date'

import { type QuoteStop, type QuoteStopDetails } from '../domain/QuoteStop'

export function getPickupAndDelivery(stops: Array<QuoteStop>): {
  pickup: QuoteStopDetails
  delivery: QuoteStopDetails
} {
  const { 0: pickup, [stops.length - 1]: delivery } = stops

  return {
    pickup: {
      description: getLaneDescription(pickup),
      ...pickup,
    },
    delivery: {
      description: getLaneDescription(delivery),
      ...delivery,
    },
  }
}

export function formatStopDate(date?: string, format = 'd LLL yyyy') {
  if (!date) {
    return 'Pending appointment'
  }

  const isoDate = parseISO(date)

  return formatDate(isoDate, format)
}

export function getStopDetailsFromStops(stops: Array<QuoteStop>): Array<StopInfo> {
  return stops.map(s => ({
    stopTitle: getLaneDescription(s),
    stopSubtitle: formatStopDate(s.date, 'MM/dd/yyyy'),
  }))
}
